<template>
  <!-- eslint-disable -->

  <div>
    <PageContainer>
      <PageHeader class="mb-6" :backButton="false">
        <template v-slot:title>SRS Codes</template>
      </PageHeader>

      <RequestTable
        ref="requestTable"
        :actions="actions"
        :pagination="true"
        :request="getVipSalesAsync"
        :showColumns="[
          'product.itemNumber',
          'product.description',
          'srsCode',
          'codeChanges',
        ]"
      />
    </PageContainer>

    <SrsCodeChangeDialog
      v-if="srsCodeChangeDialogItem"
      :opened="srsCodeChangeDialogOpened"
      :srsCode="srsCodeChangeDialogItem"
      @cancel="srsCodeChangeDialogOpened = false"
      @saved="
        srsCodeChangeDialogOpened = false;
        notificaionDialogOpened = true;
      "
    />

    <v-dialog max-width="370" v-model="notificaionDialogOpened">
      <v-card>
        <v-card-text class="pa-0">
          <v-alert class="ma-0" text type="success">
            The SRS code change has been queued!
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../../api";
import { TableAction } from "../../../components/tables/Table/TableAction";
import { ClassMemberNullError } from "../../../errors";
import { navigation } from "../../../router";

export default {
  data() {
    return {
      srsCodeChangeDialogOpened: false,
      srsCodeChangeDialogItem: undefined,
      notificaionDialogOpened: false,
      searchValue: "",
      actions: [
        new TableAction("Overview", {
          icon: "information-outline",
          click: (item) => {
            const product = item.product.itemNumber;
            const path = navigation.main.srsCodes.srsCodeDetails(product);
            this.$router.push(path);
          },
        }),
        new TableAction("SRS Code Changes", {
          icon: "list-status",
          click: (item) => {
            const product = item.product.itemNumber;
            const path = navigation.main.srsCodes.srsCodeDetails(product);
            this.$router.push({ path, query: { tab: "srsCodeChanges" } });
          },
        }),
        new TableAction(),
        new TableAction("Change SRS Code", {
          icon: "swap-horizontal",
          click: (item) => {
            this.srsCodeChangeDialogOpened = true;
            this.srsCodeChangeDialogItem = item;
          },
        }),
      ],
    };
  }, // data

  computed: {
    supplierInternalId() {
      return this.$store.state.supplierInternalId;
    },
  }, // computed

  mounted() {}, // mounted

  methods: {
    async getVipSalesAsync({ pageIndex, pageSize }) {
      ClassMemberNullError.throw(
        this.supplierInternalId,
        "supplierInternalId",
        this.getVipSalesAsync.name
      );

      const vipSalesResponse = await api.vipSales.getBySupplierPagedAsync(
        this.supplierInternalId,
        {
          pageIndex,
          pageSize,
        }
      );

      vipSalesResponse.data.forEach((vipSale) => {
        if (!vipSale.srsCodeChanges) {
          vipSale.codeChanges = 0;
          return;
        }

        vipSale.codeChanges = vipSale.srsCodeChanges.length;
      });

      return vipSalesResponse;
    },
  }, // methods

  watch: {
    supplierInternalId() {
      this.$refs.requestTable.executeRequestAsync();
    },
  }, // watch
};
</script>
